const C = require("../constants");
const initial_data = {open: false, ingredient:{id:null, name:'',}};

function ComboDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.COMBO_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default ComboDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/ComboDialogReducer.js